import { array, bool, object, oneOf, shape, string, number, arrayOf } from 'prop-types';
import { FLOWS } from '../utils/constants';

const AppFiltersType = shape({
    active: object.isRequired,
    sideBar: array.isRequired,
    subCategory: object.isRequired,
    selected: array,
    topBar: array
});

const GigCardListingsPropTypes = arrayOf(shape({
    gigs: array,
    choiceModalities: object,
    showListViewCards: bool,
    isTouch: bool,
    impressionEnrichment: object.isRequired,
    context: object.isRequired
}));

const PaginationProps = shape({
    page: number.isRequired,
    page_size: number.isRequired,
    total: number.isRequired
});

const AppDataPropTypes = shape({
    filter: AppFiltersType,
    pagination: PaginationProps,
    flow: oneOf([FLOWS.SEARCH, FLOWS.CATEGORY, FLOWS.PRO_CATEGORY, FLOWS.BUSINESS_SEARCH, FLOWS.BUSINESS_CATEGORIES])
});

const BaseListingsPerseusPropTypes = {
    listings: GigCardListingsPropTypes,
    displayData: object.isRequired,
    requestContext: object,
    topBarSorting: array.isRequired,
    appData: AppDataPropTypes
};

const ListingsPerseusPropTypes = BaseListingsPerseusPropTypes;

const SubCategoriesPropTypes = {
    appFilters: AppFiltersType,
    ...BaseListingsPerseusPropTypes
};

const SearchPropTypes = {
    appFilters: AppFiltersType,
    ...BaseListingsPerseusPropTypes
};

const ServerListingsPropTypes = {
    listings: GigCardListingsPropTypes,
    requestContext: object.isRequired,
    displayData: object.isRequired,
    topBarSorting: array.isRequired
};

const ClientListingsPropTypes = {
    listings: GigCardListingsPropTypes,
    displayData: object.isRequired,
    topBarSorting: array.isRequired,
    tracking: object.isRequired,
    requestContext: object.isRequired
};

const PaginationPropTypes = {
    pagination: PaginationProps
};

const RecentlyViewedTypes = {
    loggedIn: bool,
    activeFilters: object,
    sorting: object
};

const RecommendationsCarouselsTypes = {
    ...RecentlyViewedTypes
};

const SelectedFiltersTypes = {
    activeFilters: object.isRequired,
    selectedFilters: array
};

const EmptySearchResultsTypes = {
    displayData: shape({
        searchComponentData: shape({
            query: string.isRequired,
            isInBlackList: bool
        }),
        currentUser: shape({
            username: string.isRequired
        })
    })
};

const ErrorPageTypes = {
    errorContext: shape({
        type: string.isRequired
    })
};

const RelatedSearchTypes = {
    displayData: shape({
        searchComponentData: shape({
            modifiedQueryString: string,
            query: string.isRequired
        })
    })
};

const SearchResultsCounterTypes = {
    displayData: shape({
        searchComponentData: shape({
            modifiedQueryString: string,
            searchInsteadUrl: string,
            query: string.isRequired
        })
    })
};

const pairSelectTypes = {
    options: shape({
        fromOptions: array,
        toOptions: array
    })
};

const NumberOfResultsTypes = {
    pagination: shape({
        page: number.isRequired,
        page_size: number.isRequired,
        total: number.isRequired
    }),
    withAds: bool
};

const filterType = {
    id: string,
    options: shape({
        selected: bool
    })
};

export {
    ServerListingsPropTypes,
    ClientListingsPropTypes,
    ListingsPerseusPropTypes,
    SubCategoriesPropTypes,
    SearchPropTypes,
    PaginationPropTypes,
    RecentlyViewedTypes,
    RecommendationsCarouselsTypes,
    SelectedFiltersTypes,
    EmptySearchResultsTypes,
    ErrorPageTypes,
    RelatedSearchTypes,
    SearchResultsCounterTypes,
    pairSelectTypes,
    NumberOfResultsTypes,
    filterType
};
